// extracted by mini-css-extract-plugin
export default {"OtherPage":"OtherPage_OtherPage__1l9zu","OtherPageTitle":"OtherPage_OtherPageTitle__E3a7h","Qoute":"OtherPage_Qoute__v4yZC","Line":"OtherPage_Line__OX0FB"};